import { render, staticRenderFns } from "./CoreDetailModal.vue?vue&type=template&id=b244d2ce&scoped=true&"
import script from "./CoreDetailModal.vue?vue&type=script&lang=js&"
export * from "./CoreDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CoreDetailModal.vue?vue&type=style&index=0&id=b244d2ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b244d2ce",
  null
  
)

export default component.exports